/*!
 * BY ROBYNBLAIR — Custom Fine Art Print builder (v2)
 * One builder, two data sources: the Shopify section (mode "live") and the
 * hosted design preview (mode "demo"). No dependencies.
 */
(function () {
  'use strict';

  if (window.FineArtBuilder && window.FineArtBuilder.version) return;

  /* ------------------------------------------------------------------ *
   * Constants
   * ------------------------------------------------------------------ */

  var FRAMES = {
    NONE: { label: 'Unframed', sub: 'Print only, frame it your way' },
    WHITE: { label: 'White frame', sub: 'Framed in our studio' },
    BLACK: { label: 'Black frame', sub: 'Framed in our studio' }
  };
  var SHAPES = {
    VERTICAL: { label: 'Vertical', short: 'v' },
    HORIZONTAL: { label: 'Horizontal', short: 'h' },
    SQUARE: { label: 'Square', short: 's' }
  };
  var COLOR_FAMILIES = [
    { id: 'pink', label: 'Pink', sw: '#f7a6c8', words: ['pink', 'blush', 'coral', 'cotton candy', 'rose'] },
    { id: 'red', label: 'Cherry red', sw: '#e0453a', words: ['red', 'cherry', 'strawberry'] },
    { id: 'yellow', label: 'Sunshine', sw: '#ffc42e', words: ['yellow', 'lemon', 'sunshine', 'gelato'] },
    { id: 'green', label: 'Mint & olive', sw: 'linear-gradient(135deg,#8fd9b6 50%,#8a9a4b 50%)', words: ['mint', 'olive', 'green', 'meadow'] },
    { id: 'blue', label: 'Pool blue', sw: '#7fd0ea', words: ['blue', 'aqua', 'pool', 'riviera'] },
    { id: 'lilac', label: 'Lilac', sw: '#b9a3e3', words: ['purple', 'lilac', 'lavender'] },
    { id: 'neutral', label: 'Cream & cocoa', sw: 'linear-gradient(135deg,#f1e6d2 50%,#8a5a44 50%)', words: ['cocoa', 'cream', 'vanilla'] },
    { id: 'mix', label: 'Candy mix', sw: 'conic-gradient(#ff3d9a 0 25%,#ffc42e 0 50%,#34c98b 0 75%,#1fb6d6 0)', words: [] }
  ];
  var DEFAULT_TIER_LABELS = ['Mini', 'Square', 'Fun Sized', 'Small', 'Medium', 'Large', 'X-Large', 'Oversized'];
  var ALLOWED = /[A-Z0-9 &'!?.,\-#@:+\/()$%*"]/;

  var ICON = {
    search: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="9" cy="9" r="6"/><path d="m14 14 4 4" stroke-linecap="round"/></svg>',
    check: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m2.5 6.2 2.3 2.3L9.5 3.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    link: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M8.5 11.5a3.5 3.5 0 0 0 5 0l2.5-2.5a3.5 3.5 0 0 0-5-5l-1 1"/><path d="M11.5 8.5a3.5 3.5 0 0 0-5 0L4 11a3.5 3.5 0 0 0 5 5l1-1"/></svg>',
    bag: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7h12l-1 10H5z"/><path d="M7.5 7V5.5a2.5 2.5 0 0 1 5 0V7"/></svg>',
    frame: '<svg viewBox="0 0 30 30" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="7" y="4" width="16" height="21"/><rect x="10" y="7" width="10" height="15"/></svg>',
    sofa: '<svg viewBox="0 0 30 30" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="11" y="3" width="8" height="8"/><path d="M5 20v-4a2 2 0 0 1 4 0v1h12v-1a2 2 0 0 1 4 0v4a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"/><path d="M8 22v2M22 22v2"/></svg>'
  };

  var SOFA_SVG =
    '<svg viewBox="0 0 84 34" aria-hidden="true" focusable="false">' +
    '<rect x="4" y="3" width="76" height="20" rx="7" fill="#f2c6d6"/>' +
    '<circle cx="27" cy="14.5" r="5.2" fill="#f6b3ca"/><circle cx="57" cy="14.5" r="5.2" fill="#f6b3ca"/>' +
    '<rect x="0" y="11" width="13" height="19" rx="6" fill="#ebb9cb"/>' +
    '<rect x="71" y="11" width="13" height="19" rx="6" fill="#ebb9cb"/>' +
    '<rect x="8" y="19" width="68" height="11" rx="4.5" fill="#f6d3df"/>' +
    '<rect x="11" y="30" width="2.4" height="4" rx="1" fill="#b98f9f"/><rect x="70.6" y="30" width="2.4" height="4" rx="1" fill="#b98f9f"/>' +
    '</svg>';

  /* ------------------------------------------------------------------ *
   * Small helpers
   * ------------------------------------------------------------------ */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function slugify(s) {
    return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function formatMoney(cents, format) {
    var fmt = format || String.fromCharCode(36) + '{{amount}}';
    var value = (Number(cents) || 0) / 100;
    function group(n, dec, thousands, decimal) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        default: return group(value, 2, ',', '.');
      }
    }).replace(/<[^>]+>/g, '');
  }
  function parseDims(size) {
    // '9" x 12 1/2"' -> [9, 12.5]
    var parts = String(size || '').replace(/["”″]/g, '').split(/\s*[x×]\s*/i);
    return parts.slice(0, 2).map(function (p) {
      var n = 0;
      p.trim().split(/\s+/).forEach(function (bit) {
        if (bit.indexOf('/') > -1) { var f = bit.split('/'); n += Number(f[0]) / Number(f[1]); }
        else n += Number(bit) || 0;
      });
      return n;
    });
  }
  function fmtNum(n) {
    var whole = Math.floor(n + 1e-6);
    var frac = Math.round((n - whole) * 4) / 4;
    var map = { 0: '', 0.25: '¼', 0.5: '½', 0.75: '¾' };
    return String(whole) + (map[frac] != null ? map[frac] : '');
  }
  function fmtDims(d) { return fmtNum(d[0]) + ' × ' + fmtNum(d[1]) + ' in'; }
  function debounce(fn, ms) {
    var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); };
  }
  function sizeKey(title) { return String(title || '').replace(/["”″]/g, '').replace(/\s+/g, ' ').trim(); }

  /* ------------------------------------------------------------------ *
   * Text: normalise + balanced wrap into <= maxLines of <= maxChars
   * ------------------------------------------------------------------ */

  function normaliseText(raw) {
    var removed = false;
    var s = String(raw || '')
      .replace(/[‘’‛′]/g, "'").replace(/[“”″]/g, '"').replace(/[–—]/g, '-')
      .toUpperCase();
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var ch = s[i];
      if (ch === '\n' || ALLOWED.test(ch)) out += ch;
      else if (/\s/.test(ch)) out += ' ';
      else removed = true;
    }
    return { text: out, removed: removed };
  }

  function greedy(words, width) {
    var lines = [], cur = '';
    words.forEach(function (w) {
      if (!cur) cur = w;
      else if ((cur + ' ' + w).length <= width) cur += ' ' + w;
      else { lines.push(cur); cur = w; }
    });
    if (cur) lines.push(cur);
    return lines;
  }

  function wrapText(raw, maxChars, maxLines) {
    var norm = normaliseText(raw);
    var paras = norm.text.split('\n').map(function (p) { return p.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
    var result = { lines: [], removed: norm.removed, error: null, longWord: null };
    if (!paras.length) return result;
    var lines = [];
    for (var i = 0; i < paras.length; i++) {
      var words = paras[i].split(' ');
      var longest = words.reduce(function (m, w) { return Math.max(m, w.length); }, 0);
      if (longest > maxChars) {
        result.error = 'long';
        result.longWord = words.filter(function (w) { return w.length > maxChars; })[0];
        // still show something sensible
        lines = lines.concat(greedy(words, Math.max(longest, maxChars)));
        continue;
      }
      var target = greedy(words, maxChars).length;
      var best = greedy(words, maxChars);
      for (var w = longest; w <= maxChars; w++) {
        var trial = greedy(words, w);
        if (trial.length <= target) { best = trial; break; }
      }
      lines = lines.concat(best);
    }
    if (!result.error && lines.length > maxLines) result.error = 'lines';
    result.lines = lines;
    return result;
  }

  /* ------------------------------------------------------------------ *
   * Image analysis (same-origin images only; fails silently otherwise)
   * ------------------------------------------------------------------ */

  var analysisCache = {};
  function analyseImage(img, key) {
    if (analysisCache[key]) return analysisCache[key];
    var res = { paper: false, ink: null };
    try {
      var c = document.createElement('canvas');
      var W = 64, H = Math.max(24, Math.round(64 * (img.naturalHeight / img.naturalWidth || 1)));
      c.width = W; c.height = H;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, W, H);
      var d = ctx.getImageData(0, 0, W, H).data;
      var ring = 0, white = 0, sum = 0, n = 0;
      for (var y = 0; y < H; y++) {
        for (var x = 0; x < W; x++) {
          var i = (y * W + x) * 4, r = d[i], g = d[i + 1], b = d[i + 2];
          if (x < 2 || y < 2 || x >= W - 2 || y >= H - 2) {
            ring++;
            var mn = Math.min(r, g, b), mx = Math.max(r, g, b);
            if (mn >= 244 && mx - mn < 12) white++;
          }
          if (y > H * 0.18 && y < H * 0.42 && x > W * 0.15 && x < W * 0.85) {
            sum += 0.2126 * r + 0.7152 * g + 0.0722 * b; n++;
          }
        }
      }
      res.paper = ring > 0 && white / ring >= 0.85;
      res.ink = n ? (sum / n > 185 ? 'black' : 'white') : null;
      res.lum = n ? Math.round(sum / n) : null;
    } catch (e) { /* tainted canvas: keep defaults */ }
    analysisCache[key] = res;
    return res;
  }

  function classifyThumb(img) {
    try {
      var c = document.createElement('canvas'); c.width = 40; c.height = 40;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, 40, 40);
      var d = ctx.getImageData(0, 0, 40, 40).data, bins = {}, n = 0;
      for (var i = 0; i < d.length; i += 4) {
        var r = d[i] / 255, g = d[i + 1] / 255, b = d[i + 2] / 255;
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, h = 0, s = 0;
        if (l > 0.95 || l < 0.06) continue;
        if (mx !== mn) {
          var dd = mx - mn; s = l > 0.5 ? dd / (2 - mx - mn) : dd / (mx + mn);
          h = mx === r ? (g - b) / dd + (g < b ? 6 : 0) : mx === g ? (b - r) / dd + 2 : (r - g) / dd + 4; h *= 60;
        }
        var f;
        if (s < 0.18) f = 'neutral';
        else if (h >= 345 || h < 15) f = l > 0.68 ? 'pink' : 'red';
        else if (h < 45) f = l > 0.72 ? 'pink' : 'yellow';
        else if (h < 70) f = 'yellow';
        else if (h < 170) f = 'green';
        else if (h < 255) f = 'blue';
        else if (h < 290) f = 'lilac';
        else f = 'pink';
        bins[f] = (bins[f] || 0) + 1; n++;
      }
      var sorted = Object.keys(bins).sort(function (a, b) { return bins[b] - bins[a]; });
      var fams = sorted.filter(function (k) { return bins[k] / n > 0.2; }).slice(0, 2);
      if (sorted.length >= 4 && bins[sorted[0]] / n < 0.4) fams = ['mix'].concat(fams.slice(0, 1));
      return fams.length ? fams : sorted.slice(0, 1);
    } catch (e) { return null; }
  }

  /* ------------------------------------------------------------------ *
   * Builder
   * ------------------------------------------------------------------ */

  function Builder(root, cfg) {
    this.root = root;
    this.cfg = cfg;
    this.uid = 'fab-' + (cfg.sectionId || Math.random().toString(36).slice(2, 8));
    this.maxLines = cfg.maxLines || 3;
    this.maxChars = cfg.maxChars || 13;
    this.prepareData();
    this.state = this.initialState();
    this.render();
    this.bind();
    this.update({ initial: true });
    this.afterMount();
  }

  var P = Builder.prototype;

  P.img = function (url, width) {
    if (!url) return '';
    if (this.cfg.imageUrl) return this.cfg.imageUrl(url, width);
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    try {
      var x = new URL(u, location.href);
      x.searchParams.set('width', String(width));
      return x.toString();
    } catch (e) { return url; }
  };

  P.prepareData = function () {
    var cfg = this.cfg, self = this;
    cfg.presets = (cfg.presets || []).map(function (t) { return String(t || '').toUpperCase().replace(/\s+/g, ' ').trim(); }).filter(Boolean);
    if (!cfg.collections && cfg.collectionsText) {
      cfg.collections = String(cfg.collectionsText).split(/\n+/).map(function (line) {
        var i = line.indexOf(':');
        var tag = (i > -1 ? line.slice(0, i) : line).trim();
        var label = (i > -1 ? line.slice(i + 1) : line).trim() || tag;
        return tag ? { tag: tag, label: label } : null;
      }).filter(Boolean);
    }
    if (typeof cfg.tierLabels === 'string') cfg.tierLabels = cfg.tierLabels.split(',');
    if (cfg.photoType) {
      var pt = String(cfg.photoType).toLowerCase();
      (cfg.prints || []).forEach(function (p) { if (String(p.type || '').toLowerCase() !== pt) p.photos = []; });
    }

    // --- sizes: pair unframed / framed variants into tiers by price order
    var byFrame = {};
    (cfg.variants || []).forEach(function (v) {
      v.key = sizeKey(v.title);
      v.dims = parseDims(v.size);
      (byFrame[v.frame] = byFrame[v.frame] || []).push(v);
    });
    Object.keys(byFrame).forEach(function (f) {
      byFrame[f].sort(function (a, b) { return a.price - b.price || (a.dims[0] * a.dims[1]) - (b.dims[0] * b.dims[1]); });
    });
    this.frames = ['NONE', 'WHITE', 'BLACK'].filter(function (f) { return byFrame[f] && byFrame[f].length; });
    Object.keys(byFrame).forEach(function (f) { if (self.frames.indexOf(f) < 0) self.frames.push(f); });
    var base = byFrame.NONE || byFrame[this.frames[0]] || [];
    var labels = (cfg.tierLabels || []).map(function (l) { return String(l).trim(); }).filter(Boolean);
    if (!labels.length) labels = DEFAULT_TIER_LABELS;
    this.tiers = base.map(function (v, i) {
      var square = Math.abs(v.dims[0] - v.dims[1]) < 0.01;
      var oriSrc = typeof v.orientations === 'string' ? v.orientations.split(',') : (v.orientations || []);
      var ori = oriSrc.map(function (o) { return String(o).trim().toUpperCase(); }).filter(function (o) { return SHAPES[o]; });
      if (!ori.length) ori = square ? ['SQUARE'] : ['VERTICAL', 'HORIZONTAL'];
      var label = labels[i] || fmtDims(v.dims);
      var t = { idx: i, label: label, slug: slugify(label) || String(i), paper: v.dims, orientations: ori, byFrame: {} };
      self.frames.forEach(function (f) { if (byFrame[f] && byFrame[f][i]) t.byFrame[f] = byFrame[f][i]; });
      return t;
    });
    this.shapes = ['VERTICAL', 'HORIZONTAL', 'SQUARE'].filter(function (s) {
      return self.tiers.some(function (t) { return t.orientations.indexOf(s) > -1; });
    });
    this.minPrice = (cfg.variants || []).reduce(function (m, v) { return Math.min(m, v.price); }, Infinity);

    // --- prints
    var overrides = {};
    String(cfg.colorOverrides || '').split(/\n+/).forEach(function (line) {
      var m = line.split(':');
      if (m.length < 2) return;
      var h = m[0].trim().toLowerCase();
      var fams = m.slice(1).join(':').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(function (s) {
        return COLOR_FAMILIES.some(function (c) { return c.id === s; });
      });
      if (h && fams.length) overrides[h] = fams;
    });
    this.collections = (cfg.collections || []).filter(function (c) {
      return (cfg.prints || []).some(function (p) { return (p.tags || []).indexOf(c.tag) > -1; });
    });
    this.prints = (cfg.prints || []).filter(function (p) { return p && p.img && (p.img.v || p.img.s || p.img.h); }).map(function (p, i) {
      p.index = i;
      p.handle = p.handle || slugify(p.title);
      var name = String(p.title || '').toLowerCase();
      p.colors = overrides[p.handle] || p.colors || null;
      if (!p.colors) {
        var byName = COLOR_FAMILIES.filter(function (c) {
          return c.words.some(function (w) { return new RegExp('\\b' + w + '\\b').test(name); });
        }).map(function (c) { return c.id; });
        if (byName.length) p.colors = byName.slice(0, 2);
      }
      p.search = (p.title + ' ' + (p.tags || []).join(' ')).toLowerCase();
      if (p.cart && p.cart.variants) {
        var norm = {};
        Object.keys(p.cart.variants).forEach(function (k) { norm[sizeKey(k)] = p.cart.variants[k]; });
        p.cart.variants = norm;
      }
      return p;
    });
  };

  P.initialState = function () {
    var cfg = this.cfg, self = this;
    var s = {
      print: 0,
      text: '',
      preset: null,
      ink: 'white',
      inkTouched: false,
      frame: this.frames[0] || 'NONE',
      shape: this.shapes[0] || 'VERTICAL',
      tier: 0,
      view: 'design',
      filter: { q: '', collection: null, color: null }
    };
    var want = cfg.initial || {};
    if (cfg.mode === 'live') {
      try {
        var q = new URLSearchParams(location.search);
        if (q.get('p')) want.print = q.get('p');
        if (q.get('t')) want.text = q.get('t').split('|').join('\n');
        if (q.get('ink')) want.ink = q.get('ink');
        if (q.get('f')) want.frame = q.get('f');
        if (q.get('o')) want.shape = q.get('o');
        if (q.get('s')) want.size = q.get('s');
      } catch (e) { /* ignore */ }
    }
    if (want.print != null) {
      var idx = this.prints.findIndex(function (p) { return p.handle === want.print || String(p.id) === String(want.print); });
      if (idx > -1) s.print = idx;
    }
    if (want.text) {
      s.text = String(want.text);
      var preset = (cfg.presets || []).indexOf(s.text.toUpperCase().replace(/\s+/g, ' ').trim());
      s.preset = preset > -1 ? preset : null;
    }
    if (want.ink === 'white' || want.ink === 'black') { s.ink = want.ink; s.inkTouched = true; }
    if (want.frame) {
      var f = String(want.frame).toUpperCase();
      if (this.frames.indexOf(f) > -1) s.frame = f;
    }
    if (want.shape) {
      var sh = String(want.shape).toUpperCase();
      var full = { V: 'VERTICAL', H: 'HORIZONTAL', S: 'SQUARE' }[sh] || sh;
      if (this.shapes.indexOf(full) > -1) s.shape = full;
    }
    var tierIdx = this.tiers.findIndex(function (t) { return t.slug === want.size && t.orientations.indexOf(s.shape) > -1; });
    s.tier = tierIdx > -1 ? tierIdx : this.firstTierFor(s.shape);
    return s;
  };

  P.firstTierFor = function (shape, nearTier) {
    var list = this.tiers.filter(function (t) { return t.orientations.indexOf(shape) > -1; });
    if (!list.length) return 0;
    if (nearTier == null) return list[0].idx;
    var ref = this.tiers[nearTier] ? this.tiers[nearTier].byFrame.NONE || this.tiers[nearTier].byFrame[this.frames[0]] : null;
    var refPrice = ref ? ref.price : 0;
    list.sort(function (a, b) {
      var pa = (a.byFrame.NONE || a.byFrame[Object.keys(a.byFrame)[0]]).price;
      var pb = (b.byFrame.NONE || b.byFrame[Object.keys(b.byFrame)[0]]).price;
      return Math.abs(pa - refPrice) - Math.abs(pb - refPrice);
    });
    return list[0].idx;
  };

  /* ---------------- derived values ---------------- */

  P.currentPrint = function () { return this.prints[this.state.print]; };
  P.currentTier = function () { return this.tiers[this.state.tier]; };
  P.currentVariant = function () {
    var t = this.currentTier();
    return t ? t.byFrame[this.state.frame] : null;
  };
  P.cartLine = function () {
    var p = this.currentPrint(), v = this.currentVariant();
    if (!p || !v) return null;
    var map = (p.cart && p.cart.variants) || {};
    var hit = map[v.key];
    if (hit == null) return null;
    if (Array.isArray(hit)) hit = { id: hit[0], price: hit[1], available: hit[2] !== 0 && hit[2] !== false };
    else if (typeof hit === 'number' || typeof hit === 'string') hit = { id: Number(hit) };
    return { id: hit.id, price: hit.price != null ? hit.price : v.price, key: v.key, available: hit.available !== false && v.available !== false };
  };
  P.orientedDims = function (dims, shape) {
    var a = Math.min(dims[0], dims[1]), b = Math.max(dims[0], dims[1]);
    return shape === 'HORIZONTAL' ? [b, a] : shape === 'SQUARE' ? [dims[0], dims[1]] : [a, b];
  };
  P.artSource = function (p, shape) {
    var key = SHAPES[shape].short;
    return p.img[key] || p.img.v || p.img.s || p.img.h;
  };
  P.wrapped = function () { return wrapText(this.state.text, this.maxChars, this.maxLines); };
  P.textValid = function () {
    var w = this.wrapped();
    return w.lines.length > 0 && !w.error;
  };

  /* ---------------- render (static skeleton) ---------------- */

  P.render = function () {
    var cfg = this.cfg, self = this, id = this.uid;
    var presets = (cfg.presets || []).map(function (t, i) {
      return '<button type="button" class="fab-preset" data-preset="' + i + '" aria-pressed="false">' + esc(t) + '</button>';
    }).join('');

    var colorsInUse = COLOR_FAMILIES.filter(function (c) {
      return self.prints.some(function (p) { return (p.colors || []).indexOf(c.id) > -1; });
    });

    var html = '' +
      '<div class="fab__layout">' +
      '<div class="fab__stage-col">' +
      '<div class="fab-stage">' +
      '<div class="fab-stage__canvas" data-ref="canvas">' +
      '<div class="fab-stage__toolbar">' +
      '<span class="fab-pill"><span class="fab-pill__dot"></span>Live preview</span>' +
      '<div class="fab-seg" role="group" aria-label="Preview view">' +
      '<button type="button" data-view="design" aria-pressed="true">Design</button>' +
      '<button type="button" data-view="wall" aria-pressed="false">On the wall</button>' +
      '</div>' +
      '</div>' +
      '<div class="fab-view fab-view--design" data-ref="viewDesign">' + this.artMarkup('design') + '</div>' +
      '<div class="fab-view fab-view--wall" data-ref="viewWall" hidden>' +
      '<div class="fab-wall" data-ref="wall">' +
      '<div class="fab-wall__floor"></div>' +
      '<div class="fab-wall__sofa" data-ref="sofa">' + SOFA_SVG + '</div>' +
      '<div class="fab-wall__art" data-ref="wallArt">' + this.artMarkup('wall') + '</div>' +
      '<div class="fab-wall__dim" data-ref="wallDim"></div>' +
      '<p class="fab-wall__note">Shown to scale over an 84 in sofa</p>' +
      '</div>' +
      '</div>' +
      '<div class="fab-view fab-view--photo" data-ref="viewPhoto" hidden><img alt="" data-ref="photo"></div>' +
      '</div>' +
      '<div class="fab-stage__thumbs" data-ref="thumbs" role="group" aria-label="Preview options"></div>' +
      '<p class="fab-stage__caption" data-ref="caption" aria-live="polite"></p>' +
      '</div>' +
      '</div>' +

      '<div class="fab__build-col">' +
      '<header class="fab-intro">' +
      '<div class="fab-intro__pills">' + (cfg.pills || ['Made to order', 'Signed by Robyn']).map(function (t, i) {
        return '<span class="fab-tag' + (i === 1 ? ' fab-tag--pool' : i === 2 ? ' fab-tag--sun' : '') + '">' + esc(t) + '</span>';
      }).join('') + '</div>' +
      '<h1 class="fab-intro__title">' + (cfg.titleHtml || esc(cfg.productTitle || 'Custom Fine Art Print')) + '</h1>' +
      (cfg.lede ? '<p class="fab-intro__lede">' + esc(cfg.lede) + '</p>' : '') +
      '<p class="fab-intro__price">From<strong>' + esc(formatMoney(this.minPrice, cfg.moneyFormat)) + '</strong></p>' +
      '</header>' +

      '<ol class="fab-steps">' +

      // Step 1 — print
      '<li class="fab-step" data-step="print" id="' + id + '-step-print">' +
      '<fieldset>' +
      '<legend class="fab-sr">Step 1: Pick your print</legend>' +
      '<div class="fab-step__head" aria-hidden="true"><span class="fab-step__num">1</span><h2 class="fab-step__title">Pick your print</h2><span class="fab-step__value" data-ref="valPrint"></span></div>' +
      '<div class="fab-filter">' +
      '<div class="fab-search">' + ICON.search +
      '<label class="fab-sr" for="' + id + '-q">Search prints</label>' +
      '<input id="' + id + '-q" type="search" autocomplete="off" placeholder="Search ' + this.prints.length + ' prints" data-ref="q">' +
      '<button type="button" class="fab-search__clear" data-ref="qClear" aria-label="Clear search" hidden>×</button>' +
      '</div>' +
      (this.collections.length ? '<div class="fab-chips" role="group" aria-label="Collections"><button type="button" class="fab-chip" data-collection="" aria-pressed="true">All prints</button>' +
        this.collections.map(function (c) { return '<button type="button" class="fab-chip" data-collection="' + esc(c.tag) + '" aria-pressed="false">' + esc(c.label) + '</button>'; }).join('') + '</div>' : '') +
      (colorsInUse.length > 1 ? '<div class="fab-swatches" role="group" aria-label="Color"><span class="fab-swatches__label">Color</span>' +
        colorsInUse.map(function (c) { return '<button type="button" class="fab-swatch" style="--sw:' + c.sw + '" data-color="' + c.id + '" aria-pressed="false" title="' + esc(c.label) + '"><span class="fab-sr">' + esc(c.label) + '</span></button>'; }).join('') + '</div>' : '') +
      '</div>' +
      '<div class="fab-grid-wrap"><div class="fab-grid" data-ref="grid">' + this.gridMarkup() + '</div></div>' +
      '<div class="fab-grid__meta"><span data-ref="count" aria-live="polite"></span><button type="button" class="fab-linkbtn" data-ref="clearFilters" hidden>Clear filters</button></div>' +
      '</fieldset>' +
      '</li>' +

      // Step 2 — words
      '<li class="fab-step" data-step="words" id="' + id + '-step-words">' +
      '<fieldset>' +
      '<legend class="fab-sr">Step 2: Add your words</legend>' +
      '<div class="fab-step__head" aria-hidden="true"><span class="fab-step__num">2</span><h2 class="fab-step__title">Say something sweet</h2><span class="fab-step__value" data-ref="valWords"></span></div>' +
      '<p class="fab-step__hint">Tap a favorite or write your own. Up to ' + this.maxLines + ' lines of ' + this.maxChars + ' characters.</p>' +
      (presets ? '<div class="fab-presets" role="group" aria-label="Favorite phrases">' + presets + '</div>' : '') +
      '<div class="fab-text">' +
      '<label for="' + id + '-text">Your words</label>' +
      '<textarea id="' + id + '-text" rows="3" spellcheck="false" autocapitalize="characters" placeholder="Type your phrase. Press return to start a new line." data-ref="text" aria-describedby="' + id + '-fit ' + id + '-msg"></textarea>' +
      '<div class="fab-fit" id="' + id + '-fit" data-ref="fit"></div>' +
      '<p class="fab-msg" id="' + id + '-msg" data-ref="msg" aria-live="polite"></p>' +
      '</div>' +
      '</fieldset>' +
      '</li>' +

      // Step 3 — ink
      '<li class="fab-step is-done" data-step="ink">' +
      '<fieldset>' +
      '<legend class="fab-sr">Step 3: Text color</legend>' +
      '<div class="fab-step__head" aria-hidden="true"><span class="fab-step__num">3</span><h2 class="fab-step__title">Choose your ink</h2><span class="fab-step__value" data-ref="valInk"></span></div>' +
      '<div class="fab-options fab-options--2">' +
      ['white', 'black'].map(function (ink) {
        return '<label class="fab-opt"><input type="radio" name="' + id + '-ink" value="' + ink + '">' +
          '<span class="fab-opt__card"><span class="fab-ink-swatch fab-ink-swatch--' + ink + '">A</span>' +
          '<span class="fab-opt__title">' + (ink === 'white' ? 'White' : 'Black') + ' letters</span>' +
          '<span class="fab-opt__sub">' + (ink === 'white' ? 'Pops on bold, busy prints' : 'Crisp on pale, airy prints') + '</span></span>' +
          '<span class="fab-opt__badge" data-ink-badge="' + ink + '" hidden>Best contrast</span></label>';
      }).join('') +
      '</div>' +
      '</fieldset>' +
      '</li>' +

      // Step 4 — frame
      '<li class="fab-step is-done" data-step="frame">' +
      '<fieldset>' +
      '<legend class="fab-sr">Step 4: Frame</legend>' +
      '<div class="fab-step__head" aria-hidden="true"><span class="fab-step__num">4</span><h2 class="fab-step__title">Frame it, or don’t</h2><span class="fab-step__value" data-ref="valFrame"></span></div>' +
      '<div class="fab-options fab-options--3">' +
      this.frames.map(function (f) {
        var meta = FRAMES[f] || { label: f, sub: '' };
        return '<label class="fab-opt"><input type="radio" name="' + id + '-frame" value="' + f + '">' +
          '<span class="fab-opt__card"><span class="fab-frame-icon fab-frame-icon--' + f + '"><i></i></span>' +
          '<span class="fab-opt__title">' + esc(meta.label) + '</span>' +
          '<span class="fab-opt__sub">' + esc(meta.sub) + '</span>' +
          '<span class="fab-opt__price" data-frame-price="' + f + '"></span></span></label>';
      }).join('') +
      '</div>' +
      '</fieldset>' +
      '</li>' +

      // Step 5 — size
      '<li class="fab-step is-done" data-step="size">' +
      '<fieldset>' +
      '<legend class="fab-sr">Step 5: Size and orientation</legend>' +
      '<div class="fab-step__head" aria-hidden="true"><span class="fab-step__num">5</span><h2 class="fab-step__title">Size it up</h2><span class="fab-step__value" data-ref="valSize"></span></div>' +
      '<div class="fab-shape" role="group" aria-label="Orientation">' +
      this.shapes.map(function (s) {
        return '<button type="button" data-shape="' + s + '" aria-pressed="false"><i></i>' + SHAPES[s].label + '</button>';
      }).join('') +
      '</div>' +
      '<div class="fab-options fab-sizes" data-ref="sizes"></div>' +
      '<details class="fab-guide"><summary>Size guide</summary><div class="fab-guide__body" data-ref="guide"></div></details>' +
      '</fieldset>' +
      '</li>' +
      '</ol>' +

      '<section class="fab-summary" data-ref="summary" aria-label="Your print">' +
      '<dl class="fab-summary__list" data-ref="summaryList"></dl>' +
      '<div class="fab-summary__price"><span class="fab-summary__total" data-ref="total" aria-live="polite"></span><span class="fab-summary__lead">' + esc(cfg.leadTime || 'Made to order. Ships in 4–6 weeks.') + '</span></div>' +
      '<button type="button" class="fab-cta" data-ref="cta">' + ICON.bag + '<span data-ref="ctaLabel">Add to cart</span></button>' +
      '<p class="fab-status" data-ref="status" role="status"></p>' +
      '<div class="fab-secondary">' +
      (cfg.share !== false ? '<button type="button" class="fab-ghost" data-ref="share">' + ICON.link + '<span>Copy design link</span></button>' : '<span></span>') +
      '<a class="fab-ghost" href="' + esc(cfg.cartUrl || '/cart') + '" data-ref="cartLink">Go to cart</a>' +
      '</div>' +
      '<div class="fab-sharebox" data-ref="sharebox"><label class="fab-sr" for="' + id + '-share">Design link</label><input id="' + id + '-share" readonly data-ref="shareInput"></div>' +
      '<div class="fab-assure">' +
      '<div><strong>Giclée on rag paper</strong>Printed on textured cotton rag and signed.</div>' +
      '<div><strong>Framed for you</strong>White or black frames arrive ready to hang.</div>' +
      '<div><strong>Made in Miami</strong>Every print is made to order in our studio.</div>' +
      '</div>' +
      '</section>' +
      '<div class="fab-after" data-ref="after"></div>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="fab-pip" data-ref="pip" aria-label="Back to the live preview" tabindex="-1">' + this.artMarkup('pip') + '</button>' +
      '<div class="fab-mbar" data-ref="mbar" aria-hidden="true">' +
      '<button type="button" class="fab-mbar__thumb" data-ref="mbarThumb" aria-label="Back to preview"><img alt="" data-ref="mbarImg"></button>' +
      '<div class="fab-mbar__info"><strong data-ref="mbarPrice"></strong><span data-ref="mbarText"></span></div>' +
      '<button type="button" class="fab-cta" data-ref="mbarCta" tabindex="-1">Add to cart</button>' +
      '</div>';

    var after = this.root.querySelector('[data-fab-after]');
    this.root.classList.add('fab');
    this.root.innerHTML = html;
    this.refs = {};
    var r = this.refs;
    this.root.querySelectorAll('[data-ref]').forEach(function (el) { r[el.getAttribute('data-ref')] = el; });
    if (after) r.after.appendChild(after);
    this.arts = [].slice.call(this.root.querySelectorAll('.fab-art'));
  };

  P.artMarkup = function (where) {
    return '' +
      '<div class="fab-art" data-where="' + where + '" data-frame="NONE" data-paper="0">' +
      '<div class="fab-art__frame">' +
      '<div class="fab-art__paper">' +
      '<div class="fab-art__window"><img class="fab-art__img" alt="" decoding="async"></div>' +
      '<div class="fab-art__words" data-ink="white"><div class="fab-art__box"></div></div>' +
      (this.cfg.signature ? '<img class="fab-art__sig" alt="" src="' + esc(this.cfg.signature) + '">' : '') +
      '</div>' +
      '</div>' +
      '</div>';
  };

  P.gridMarkup = function () {
    var self = this, id = this.uid;
    return this.prints.map(function (p, i) {
      return '<label class="fab-print" data-print="' + i + '">' +
        '<input type="radio" name="' + id + '-print" value="' + i + '">' +
        '<span class="fab-print__img"><img alt="" loading="lazy" decoding="async" width="240" height="240" src="' + esc(self.img(p.img.t || p.img.s || p.img.v, 240)) + '" data-thumb="' + i + '"><span class="fab-print__check">' + ICON.check + '</span></span>' +
        '<span class="fab-print__name">' + esc(p.title) + '</span>' +
        '</label>';
    }).join('') + '<p class="fab-empty" data-ref="empty" hidden>No prints match. <button type="button" class="fab-linkbtn" data-clear>Clear filters</button></p>';
  };

  /* ---------------- events ---------------- */

  P.bind = function () {
    var self = this, r = this.refs, root = this.root;

    ['change', 'click', 'input'].forEach(function (type) {
      root.addEventListener(type, function () { self.touched = true; }, true);
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === self.uid + '-print') { self.setPrint(Number(t.value)); }
      else if (t.name === self.uid + '-ink') { self.state.ink = t.value; self.state.inkTouched = true; self.update(); }
      else if (t.name === self.uid + '-frame') { self.state.frame = t.value; self.update(); }
      else if (t.name === self.uid + '-tier') { self.state.tier = Number(t.value); self.update(); }
    });

    root.addEventListener('click', function (e) {
      var el;
      if ((el = e.target.closest('[data-preset]'))) {
        var i = Number(el.getAttribute('data-preset'));
        if (self.state.preset === i) return;
        self.state.preset = i;
        self.state.text = self.cfg.presets[i];
        r.text.value = self.state.text;
        self.update();
      } else if ((el = e.target.closest('[data-shape]')) && el.tagName === 'BUTTON' && !el.disabled) {
        var shape = el.getAttribute('data-shape');
        if (shape === self.state.shape) return;
        var t = self.currentTier();
        self.state.shape = shape;
        if (!t || t.orientations.indexOf(shape) < 0) self.state.tier = self.firstTierFor(shape, self.state.tier);
        self.update();
      } else if ((el = e.target.closest('[data-view]'))) {
        self.setView(el.getAttribute('data-view'));
      } else if ((el = e.target.closest('[data-thumbview]'))) {
        self.setView(el.getAttribute('data-thumbview'));
      } else if ((el = e.target.closest('[data-collection]'))) {
        var c = el.getAttribute('data-collection') || null;
        self.state.filter.collection = c;
        self.applyFilter();
      } else if ((el = e.target.closest('[data-color]'))) {
        var col = el.getAttribute('data-color');
        self.state.filter.color = self.state.filter.color === col ? null : col;
        self.applyFilter();
      } else if (e.target.closest('[data-clear]') || e.target === r.clearFilters) {
        self.clearFilters();
      }
    });

    r.text.addEventListener('input', function () {
      self.state.text = r.text.value;
      var norm = r.text.value.toUpperCase().replace(/\s+/g, ' ').trim();
      var i = (self.cfg.presets || []).indexOf(norm);
      self.state.preset = i > -1 ? i : null;
      self.update({ fromText: true });
    });

    r.q.addEventListener('input', debounce(function () {
      self.state.filter.q = r.q.value.trim().toLowerCase();
      self.applyFilter();
    }, 120));
    r.qClear.addEventListener('click', function () { r.q.value = ''; self.state.filter.q = ''; self.applyFilter(); r.q.focus(); });

    r.cta.addEventListener('click', function () { self.addToCart(); });
    r.mbarCta.addEventListener('click', function () { self.addToCart(); });
    var toStage = function () { r.canvas.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
    r.mbarThumb.addEventListener('click', toStage);
    r.pip.addEventListener('click', toStage);
    if (r.share) r.share.addEventListener('click', function () { self.copyLink(); });

    // grid images: classify colors for prints without data
    r.grid.addEventListener('load', function (e) {
      var img = e.target;
      if (!img.hasAttribute('data-thumb')) return;
      var p = self.prints[Number(img.getAttribute('data-thumb'))];
      if (p && !p.colors) {
        var fams = classifyThumb(img);
        if (fams) p.colors = fams;
      }
    }, true);
  };

  P.afterMount = function () {
    var self = this, r = this.refs;
    // Resize wall scene
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { self.layoutWall(); }).observe(r.canvas);
    } else {
      window.addEventListener('resize', function () { self.layoutWall(); });
    }
    // Mobile bar visibility
    if ('IntersectionObserver' in window) {
      var seen = { summary: false, stage: true };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === r.summary) seen.summary = en.isIntersecting;
          if (en.target === r.canvas) seen.stage = en.isIntersecting;
        });
        var show = !seen.summary && !seen.stage;
        r.pip.classList.toggle('is-visible', !seen.stage);
        r.pip.tabIndex = !seen.stage ? 0 : -1;
        r.mbar.classList.toggle('is-visible', show);
        r.mbar.setAttribute('aria-hidden', show ? 'false' : 'true');
        r.mbarCta.tabIndex = show ? 0 : -1;
      }, { threshold: 0 });
      io.observe(r.summary); io.observe(r.canvas);
    }
    // Refit words once fonts are ready
    if (document.fonts && document.fonts.ready) {
      document.fonts.load('100px Anton').catch(function () {}).then(function () { self.fitWords(); });
      document.fonts.ready.then(function () { self.fitWords(); });
    }
    this.pushUrl = debounce(function () { self.syncUrl(); }, 400);
  };

  /* ---------------- state changes ---------------- */

  P.setPrint = function (i) {
    if (i === this.state.print) return;
    this.state.print = i;
    if (this.state.view !== 'design' && this.state.view !== 'wall') this.state.view = 'design';
    this.update({ printChanged: true });
  };

  P.setView = function (v) {
    this.state.view = v;
    this.updateViews();
  };

  P.clearFilters = function () {
    this.state.filter = { q: '', collection: null, color: null };
    this.refs.q.value = '';
    this.applyFilter();
  };

  P.applyFilter = function () {
    var f = this.state.filter, r = this.refs, shown = 0, self = this;
    this.root.querySelectorAll('.fab-print').forEach(function (el) {
      var p = self.prints[Number(el.getAttribute('data-print'))];
      var ok = (!f.q || p.search.indexOf(f.q) > -1) &&
        (!f.collection || (p.tags || []).indexOf(f.collection) > -1) &&
        (!f.color || (p.colors || []).indexOf(f.color) > -1);
      el.hidden = !ok;
      if (ok) shown++;
    });
    this.root.querySelectorAll('[data-collection]').forEach(function (b) {
      b.setAttribute('aria-pressed', String((b.getAttribute('data-collection') || null) === f.collection));
    });
    this.root.querySelectorAll('[data-color]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-color') === f.color));
    });
    var filtered = !!(f.q || f.collection || f.color);
    r.count.textContent = filtered ? 'Showing ' + shown + ' of ' + this.prints.length + ' prints' : this.prints.length + ' prints';
    r.clearFilters.hidden = !filtered;
    r.qClear.hidden = !f.q;
    var empty = this.root.querySelector('[data-ref="empty"]');
    if (empty) empty.hidden = shown > 0;
    r.grid.scrollTop = 0;
  };

  /* ---------------- update (everything derived from state) ---------------- */

  P.update = function (opts) {
    opts = opts || {};
    var s = this.state, r = this.refs, cfg = this.cfg, self = this;
    var p = this.currentPrint(), tier = this.currentTier(), v = this.currentVariant();
    if (!p || !tier) return;
    var wrapped = this.wrapped();

    // inputs reflect state
    var radio = this.root.querySelector('input[name="' + this.uid + '-print"][value="' + s.print + '"]');
    if (radio && !radio.checked) radio.checked = true;
    if (opts.initial) {
      r.text.value = s.text;
      this.applyFilter();
      if (radio) {
        var label = radio.closest('.fab-print');
        if (label && label.offsetTop > r.grid.clientHeight) r.grid.scrollTop = label.offsetTop - 12;
      }
    }
    this.root.querySelectorAll('[data-preset]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-preset')) === s.preset));
    });
    this.root.querySelectorAll('input[name="' + this.uid + '-ink"]').forEach(function (i) { i.checked = i.value === s.ink; });
    this.root.querySelectorAll('input[name="' + this.uid + '-frame"]').forEach(function (i) { i.checked = i.value === s.frame; });
    this.root.querySelectorAll('.fab-shape [data-shape]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-shape') === s.shape));
    });

    // frame prices (relative to unframed at this size)
    var baseV = tier.byFrame.NONE;
    this.frames.forEach(function (f) {
      var el = self.root.querySelector('[data-frame-price="' + f + '"]');
      var fv = tier.byFrame[f];
      if (!el) return;
      if (!fv) { el.textContent = 'Not available'; return; }
      if (f === 'NONE' || !baseV) el.textContent = formatMoney(fv.price, cfg.moneyFormat);
      else el.textContent = '+' + formatMoney(fv.price - baseV.price, cfg.moneyFormat);
    });
    this.root.querySelectorAll('input[name="' + this.uid + '-frame"]').forEach(function (i) { i.disabled = !tier.byFrame[i.value]; });

    this.renderSizes();
    this.renderGuide();
    this.renderFit(wrapped);
    this.renderArt(wrapped, opts);
    this.renderThumbs(opts.printChanged || opts.initial);
    this.updateViews();

    // step values
    r.valPrint.textContent = p.title;
    r.valWords.textContent = wrapped.lines.length ? wrapped.lines.join(' ') : 'Needed';
    r.valInk.textContent = s.ink === 'white' ? 'White letters' : 'Black letters';
    r.valFrame.textContent = (FRAMES[s.frame] || { label: s.frame }).label;
    var paperDims = this.orientedDims(tier.paper, s.shape);
    r.valSize.textContent = tier.label + ' · ' + fmtDims(paperDims).replace(' in', '″');
    this.root.querySelector('[data-step="print"]').classList.add('is-done');
    this.root.querySelector('[data-step="words"]').classList.toggle('is-done', this.textValid());

    // caption
    var line = this.cartLine();
    var framed = s.frame !== 'NONE' && v ? this.orientedDims(v.dims, s.shape) : null;
    r.caption.innerHTML = '<strong>' + esc(p.title) + '</strong>' +
      '<span>' + esc(tier.label) + ', ' + esc(fmtDims(paperDims)) + (framed ? ' (' + esc(fmtDims(framed)) + ' framed)' : '') + '</span>' +
      '<span>' + esc(SHAPES[s.shape].label) + '</span>';

    // summary
    var words = wrapped.lines.length ? wrapped.lines.join('\n') : '—';
    r.summaryList.innerHTML =
      '<dt>Print</dt><dd>' + esc(p.title) + '</dd>' +
      '<dt>Words</dt><dd>' + esc(words) + '</dd>' +
      '<dt>Letters</dt><dd>' + (s.ink === 'white' ? 'White' : 'Black') + '</dd>' +
      '<dt>Frame</dt><dd>' + esc((FRAMES[s.frame] || { label: s.frame }).label) + '</dd>' +
      '<dt>Size</dt><dd>' + esc(tier.label + ', ' + fmtDims(paperDims) + ' · ' + SHAPES[s.shape].label) + '</dd>';
    var price = line ? line.price : (v ? v.price : 0);
    r.total.textContent = formatMoney(price, cfg.moneyFormat);
    r.mbarPrice.textContent = formatMoney(price, cfg.moneyFormat);
    r.mbarText.textContent = p.title + ' · ' + tier.label;
    r.mbarImg.src = this.img(p.img.t || p.img.s || p.img.v, 120);

    // CTA state
    var ready = this.textValid() && !!line && line.available !== false;
    r.cta.setAttribute('aria-disabled', String(!ready));
    r.mbarCta.setAttribute('aria-disabled', String(!ready));
    if (!this.busy) {
      r.ctaLabel.textContent = ready ? 'Add to cart · ' + formatMoney(price, cfg.moneyFormat) : (!this.textValid() ? 'Add your words to continue' : 'This combination is unavailable');
      r.mbarCta.textContent = ready ? 'Add to cart' : 'Add words';
    }
    if (!opts.initial && this.refs.status.classList.contains('is-error') && ready) this.setStatus('');
    if (r.sharebox.classList.contains('is-open')) r.shareInput.value = this.shareUrl();
    if (!opts.initial && this.touched && this.pushUrl) this.pushUrl();
  };

  P.renderSizes = function () {
    var s = this.state, self = this, cfg = this.cfg, id = this.uid;
    var list = this.tiers.filter(function (t) { return t.orientations.indexOf(s.shape) > -1; });
    var maxLong = list.reduce(function (m, t) { return Math.max(m, t.paper[0], t.paper[1]); }, 1);
    var html = list.map(function (t) {
      var fv = t.byFrame[s.frame];
      var d = self.orientedDims(t.paper, s.shape);
      var fd = fv && s.frame !== 'NONE' ? self.orientedDims(fv.dims, s.shape) : null;
      var line = null;
      var p = self.currentPrint();
      if (fv && p && p.cart && p.cart.variants) {
        var hit = p.cart.variants[fv.key];
        if (Array.isArray(hit)) line = { id: hit[0], price: hit[1], available: hit[2] !== 0 && hit[2] !== false };
        else if (hit != null) line = typeof hit === 'object' ? hit : { id: hit };
      }
      var price = fv ? (line && line.price != null ? line.price : fv.price) : null;
      var disabled = !fv || !line || fv.available === false || line.available === false;
      var w = Math.max(7, Math.round(32 * d[0] / maxLong)), h = Math.max(7, Math.round(32 * d[1] / maxLong));
      return '<label class="fab-opt"><input type="radio" name="' + id + '-tier" value="' + t.idx + '"' + (t.idx === s.tier ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
        '<span class="fab-opt__card">' +
        '<span class="fab-size__scale" aria-hidden="true"><i style="width:' + w + 'px;height:' + h + 'px"></i></span>' +
        '<span class="fab-size__name">' + esc(t.label) + '</span>' +
        '<span class="fab-opt__sub">' + esc(fmtDims(d)) + (fd ? ' print · ' + esc(fmtDims(fd)) + ' framed' : '') + '</span>' +
        '<span class="fab-opt__price">' + (price != null ? esc(formatMoney(price, cfg.moneyFormat)) : 'Unavailable') + '</span>' +
        '</span></label>';
    }).join('');
    this.refs.sizes.innerHTML = html;
  };

  P.renderGuide = function () {
    var self = this, s = this.state, cfg = this.cfg;
    var hasFramed = this.frames.some(function (f) { return f !== 'NONE'; });
    var framedKey = this.frames.filter(function (f) { return f !== 'NONE'; })[0];
    var rows = this.tiers.map(function (t) {
      var fv = framedKey ? t.byFrame[framedKey] : null;
      return '<tr' + (t.idx === s.tier ? ' class="is-current"' : '') + '><td>' + esc(t.label) + '</td><td>' + esc(fmtDims(t.paper)) + '</td>' +
        (hasFramed ? '<td>' + (fv ? esc(fmtDims(fv.dims)) : '—') + '</td>' : '') +
        '<td>' + (t.byFrame.NONE ? esc(formatMoney(t.byFrame.NONE.price, cfg.moneyFormat)) : '—') + '</td>' +
        (hasFramed ? '<td>' + (fv ? esc(formatMoney(fv.price, cfg.moneyFormat)) : '—') + '</td>' : '') + '</tr>';
    }).join('');
    this.refs.guide.innerHTML = '<table><thead><tr><th>Size</th><th>Print</th>' + (hasFramed ? '<th>Framed</th>' : '') + '<th>Unframed</th>' + (hasFramed ? '<th>With frame</th>' : '') + '</tr></thead><tbody>' + rows + '</tbody></table>' +
      '<p>Framed sizes are the outside edge of the frame. Rectangular sizes come vertical or horizontal.' + (cfg.sizeGuideUrl ? ' <a href="' + esc(cfg.sizeGuideUrl) + '" target="_blank" rel="noopener">See the full size chart</a>.' : '') + '</p>';
  };

  P.renderFit = function (w) {
    var r = this.refs, max = this.maxChars, html = '';
    for (var i = 0; i < this.maxLines; i++) {
      var line = w.lines[i] || '';
      var len = line.length;
      var cls = !len ? ' is-empty' : len > max ? ' is-over' : len === max ? ' is-full' : '';
      html += '<div class="fab-fit__row' + cls + '"><span>Line ' + (i + 1) + '</span><span class="fab-fit__bar"><i style="--p:' + Math.min(100, Math.round(100 * len / max)) + '%"></i></span><span class="fab-fit__count">' + len + '/' + max + '</span></div>';
    }
    r.fit.innerHTML = html;
    var msg = '', err = false;
    if (w.error === 'lines') { msg = 'That runs to ' + w.lines.length + ' lines. Trim a few words to fit ' + this.maxLines + '.'; err = true; }
    else if (w.error === 'long') { msg = '“' + w.longWord + '” is ' + w.longWord.length + ' characters. Each line fits ' + max + ', so try a shorter word.'; err = true; }
    else if (w.removed) msg = 'Emoji and special characters can’t be printed, so we left them out.';
    else if (w.lines.length) msg = 'We balance your lines automatically. Press return to choose your own breaks.';
    r.msg.textContent = msg;
    r.msg.classList.toggle('is-error', err);
    r.text.setAttribute('aria-invalid', String(err));
  };

  P.renderThumbs = function (rebuild) {
    var r = this.refs, p = this.currentPrint(), self = this;
    if (rebuild) {
      var html = '<button type="button" class="fab-thumb fab-thumb--icon" data-thumbview="design" aria-pressed="false">' + ICON.frame + '<span>Design</span></button>' +
        '<button type="button" class="fab-thumb fab-thumb--icon" data-thumbview="wall" aria-pressed="false">' + ICON.sofa + '<span>Scale</span></button>';
      (p.photos || []).forEach(function (ph, i) {
        html += '<button type="button" class="fab-thumb" data-thumbview="photo:' + i + '" aria-pressed="false" aria-label="Photo ' + (i + 1) + ' of ' + esc(p.title) + '"><img alt="" loading="lazy" src="' + esc(self.img(ph.src, 160)) + '"></button>';
      });
      r.thumbs.innerHTML = html;
    }
  };

  P.updateViews = function () {
    var v = this.state.view, r = this.refs, p = this.currentPrint();
    var photo = /^photo:(\d+)$/.exec(v);
    if (photo && !(p.photos || [])[Number(photo[1])]) { v = this.state.view = 'design'; photo = null; }
    r.viewDesign.hidden = v !== 'design';
    r.viewWall.hidden = v !== 'wall';
    r.viewPhoto.hidden = !photo;
    if (photo) {
      var ph = p.photos[Number(photo[1])];
      r.photo.src = this.img(ph.src, 1200);
      r.photo.alt = ph.alt || p.title;
    }
    this.root.querySelectorAll('[data-view]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-view') === v));
    });
    this.root.querySelectorAll('[data-thumbview]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-thumbview') === v));
    });
    if (v === 'wall') this.layoutWall();
  };

  /* ---------------- the artwork ---------------- */

  P.renderArt = function (wrapped, opts) {
    var s = this.state, self = this, p = this.currentPrint(), tier = this.currentTier(), v = this.currentVariant();
    var paper = this.orientedDims(tier.paper, s.shape);
    var outer = s.frame !== 'NONE' && v ? this.orientedDims(v.dims, s.shape) : paper;
    var moulding = s.frame !== 'NONE' ? ((outer[0] - paper[0]) / 2) / outer[0] * 100 : 0;
    var ar = outer[0] / outer[1];
    var short = Math.min(1, paper[1] / paper[0]); // short side as a fraction of paper width
    var src = this.artSource(p, s.shape);
    var url = this.img(src, 1400);
    var key = p.handle + ':' + s.shape;
    var lines = wrapped.lines.length ? wrapped.lines : ['YOUR WORDS', 'HERE'];
    var placeholder = !wrapped.lines.length;

    this.arts.forEach(function (art) {
      art.style.setProperty('--fab-ar', ar.toFixed(4));
      art.style.setProperty('--fab-moulding', moulding.toFixed(3) + '%');
      art.style.setProperty('--fab-margin', (6 * short).toFixed(3) + 'cqw');
      art.style.setProperty('--fab-margin-bottom', (7.6 * short).toFixed(3) + 'cqw');
      art.style.setProperty('--fab-words-top', s.shape === 'HORIZONTAL' ? '21%' : s.shape === 'SQUARE' ? '25%' : '23%');
      art.setAttribute('data-frame', s.frame);
      art.setAttribute('data-shape', s.shape);
      var words = art.querySelector('.fab-art__words');
      words.setAttribute('data-ink', s.ink);
      words.classList.toggle('is-placeholder', placeholder);
      art.querySelector('.fab-art__box').innerHTML = lines.map(function (l) { return '<span>' + esc(l) + '</span>'; }).join('');
      var img = art.querySelector('.fab-art__img');
      if (img.getAttribute('data-key') !== key) {
        img.classList.remove('is-ready');
        img.setAttribute('data-key', key);
        if (self.cfg.mode === 'live') img.crossOrigin = 'anonymous';
        img.onload = function () { self.onArtLoad(img, key); };
        img.onerror = function () { img.classList.add('is-ready'); };
        img.src = url;
        if (img.complete && img.naturalWidth) self.onArtLoad(img, key);
      } else {
        self.applyArtFit(art, img);
      }
    });
    this.root.style.setProperty('--fab-ar', ar.toFixed(4));
    this.fitWords(lines, paper);
    this.updateInkBadge();
  };

  P.onArtLoad = function (img, key) {
    if (img.getAttribute('data-key') !== key) return;
    var a = analyseImage(img, key);
    var art = img.closest('.fab-art');
    art.setAttribute('data-paper', a.paper ? '1' : '0');
    this.applyArtFit(art, img);
    img.classList.add('is-ready');
    var p = this.currentPrint();
    if (p && (p.handle + ':' + this.state.shape) === key) {
      p.inkSuggest = a.ink;
      if (!this.state.inkTouched && a.ink && a.ink !== this.state.ink) {
        this.state.ink = a.ink;
        this.update();
      } else this.updateInkBadge();
    }
  };

  P.applyArtFit = function (art, img) {
    if (!img.naturalWidth) return;
    var paperImg = art.getAttribute('data-paper') === '1';
    var paper = this.orientedDims(this.currentTier().paper, this.state.shape);
    var short = Math.min(1, paper[1] / paper[0]);
    var m = 0.06 * short, mb = 0.076 * short;
    var wa = paperImg ? paper[0] / paper[1] : (1 - 2 * m) / (paper[1] / paper[0] - m - mb);
    var ia = img.naturalWidth / img.naturalHeight;
    var mismatch = Math.abs(Math.log(ia / wa));
    art.style.setProperty('--fab-fit', paperImg || mismatch > 0.12 ? 'contain' : 'cover');
  };

  P.updateInkBadge = function () {
    var p = this.currentPrint(), sug = p && p.inkSuggest;
    this.root.querySelectorAll('[data-ink-badge]').forEach(function (b) {
      b.hidden = !sug || b.getAttribute('data-ink-badge') !== sug;
    });
  };

  var measureCtx = null;
  P.fitWords = function (lines, paper) {
    if (!lines) {
      var w = this.wrapped();
      lines = w.lines.length ? w.lines : ['YOUR WORDS', 'HERE'];
    }
    if (!paper) paper = this.orientedDims(this.currentTier().paper, this.state.shape);
    if (!measureCtx) {
      var c = document.createElement('canvas');
      measureCtx = c.getContext('2d');
    }
    var font = getComputedStyle(this.root).getPropertyValue('--fab-print') || 'Impact, Anton, sans-serif';
    measureCtx.font = '100px ' + font;
    var widest = lines.reduce(function (m, l) {
      return Math.max(m, measureCtx.measureText(l).width / 100 + 0.01 * l.length);
    }, 0.5);
    var short = Math.min(1, paper[1] / paper[0]);   // short side / width
    var heightCqw = 100 * paper[1] / paper[0];         // paper height in cqw units
    var target = 56 * short;                          // widest line = 56% of the short side
    var fs = target / widest;
    fs = Math.min(fs, 10.5 * short);                  // short words don’t get huge
    fs = Math.min(fs, (0.4 * heightCqw) / (lines.length * 1.02 + 0.6)); // leave room below
    this.arts.forEach(function (art) { art.style.setProperty('--fab-fs', fs.toFixed(3) + 'cqw'); });
  };

  /* ---------------- wall view ---------------- */

  P.layoutWall = function () {
    var r = this.refs;
    if (r.viewWall.hidden) return;
    var W = r.canvas.clientWidth, H = r.canvas.clientHeight;
    if (!W || !H) return;
    var s = this.state, tier = this.currentTier(), v = this.currentVariant();
    var paper = this.orientedDims(tier.paper, s.shape);
    var outer = s.frame !== 'NONE' && v ? this.orientedDims(v.dims, s.shape) : paper;
    var floorPx = H * 0.12;
    var usableH = H - floorPx - 64;        // keep clear of the toolbar
    var ppi = Math.min((W * 0.94) / 100, usableH / 92);
    var sofaW = 84 * ppi, sofaH = sofaW * 34 / 84;
    var artBottom = floorPx + 40 * ppi;    // about 9 in above the sofa back
    r.sofa.style.width = sofaW + 'px';
    r.sofa.style.bottom = floorPx + 'px';
    r.wallArt.style.width = (outer[0] * ppi) + 'px';
    r.wallArt.style.bottom = artBottom + 'px';
    r.wallDim.style.bottom = (artBottom + outer[1] * ppi + 10) + 'px';
    r.wallDim.textContent = fmtDims(outer) + (s.frame !== 'NONE' ? ' framed' : '');
    void sofaH;
  };

  /* ---------------- share + url ---------------- */

  P.designParams = function () {
    var s = this.state, p = this.currentPrint(), t = this.currentTier(), w = this.wrapped();
    var q = new URLSearchParams();
    q.set('p', p.handle);
    if (w.lines.length) q.set('t', w.lines.join('|'));
    q.set('ink', s.ink);
    q.set('f', s.frame.toLowerCase());
    q.set('o', SHAPES[s.shape].short);
    q.set('s', t.slug);
    return q;
  };
  P.shareUrl = function () {
    var base = this.cfg.productUrl || (location.origin + location.pathname);
    return base.split('?')[0] + '?' + this.designParams().toString();
  };
  P.syncUrl = function () {
    if (this.cfg.mode !== 'live' || !window.history || !history.replaceState) return;
    try {
      var url = new URL(location.href);
      var q = this.designParams();
      ['p', 't', 'ink', 'f', 'o', 's'].forEach(function (k) { url.searchParams.delete(k); });
      q.forEach(function (val, k) { url.searchParams.set(k, val); });
      history.replaceState(history.state, '', url.toString());
    } catch (e) { /* ignore */ }
  };
  P.copyLink = function () {
    var self = this, r = this.refs, url = this.shareUrl();
    r.shareInput.value = url;
    r.sharebox.classList.add('is-open');
    var done = function () { self.setStatus('Design link copied. Paste it anywhere to share this exact print.', 'ok'); };
    var fallback = function () { r.shareInput.focus(); r.shareInput.select(); self.setStatus('Link selected. Copy it to share this exact print.', 'ok'); };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, fallback);
      else fallback();
    } catch (e) { fallback(); }
  };

  P.setStatus = function (text, kind) {
    var el = this.refs.status;
    el.textContent = text || '';
    el.classList.toggle('is-error', kind === 'error');
    el.classList.toggle('is-ok', kind === 'ok');
  };

  /* ---------------- cart ---------------- */

  P.lineItem = function () {
    var s = this.state, p = this.currentPrint(), line = this.cartLine(), w = this.wrapped();
    if (!line) return null;
    var text = s.preset != null ? this.cfg.presets[s.preset] : w.lines.join('\n');
    var file = this.img(this.artSource(p, s.shape), 400);
    if (this.cfg.fileUrl) file = this.cfg.fileUrl(p, s.shape);
    // Property names and order match the v1 builder so orders read the same.
    var props = {};
    props['Orientation'] = s.shape;
    props['Pick Your Print'] = p.title;
    props['_PickYourPrintFile'] = file;
    props['Choose Your Text'] = text;
    props['Text Color'] = s.ink;
    props['Sizes'] = line.key;
    props['_Builder'] = 'v2';
    return { id: line.id, quantity: 1, properties: props, price: line.price };
  };

  P.addToCart = function () {
    var self = this, r = this.refs;
    if (this.busy) return;
    if (!this.textValid()) {
      var w = this.wrapped();
      this.setStatus(w.lines.length ? 'Your words don’t fit yet. Adjust them in step 2.' : 'Add your words in step 2 to finish your print.', 'error');
      var step = this.root.querySelector('[data-step="words"]');
      step.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { r.text.focus({ preventScroll: true }); }, 450);
      return;
    }
    var item = this.lineItem();
    var cl = this.cartLine();
    if (cl && cl.available === false) { this.setStatus('That size and frame is sold out for this print. Try another size or frame.', 'error'); return; }
    if (!item) { this.setStatus('That size and frame isn’t available for this print. Try another size.', 'error'); return; }

    if (this.cfg.mode === 'demo') {
      this.flashAdded();
      if (this.cfg.onDemoAdd) this.cfg.onDemoAdd(item, this);
      return;
    }

    this.busy = true;
    r.cta.classList.add('is-busy');
    r.ctaLabel.textContent = 'Adding…';
    r.cta.insertAdjacentHTML('afterbegin', '<span class="fab-cta__spin" aria-hidden="true"></span>');
    this.setStatus('');

    var fd = new FormData();
    fd.append('id', String(item.id));
    fd.append('quantity', '1');
    Object.keys(item.properties).forEach(function (k) { fd.append('properties[' + k + ']', item.properties[k]); });
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId); });
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));

    var routes = (window.Theme && window.Theme.routes) || {};
    var addUrl = this.cfg.cartAddUrl || routes.cart_add_url || '/cart/add.js';
    var cartUrl = this.cfg.cartJsUrl || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js';
    var addResp;

    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json && json.status) throw new Error(json.description || json.message || 'Something went wrong.');
        addResp = json;
        return fetch(cartUrl, { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); }).catch(function () { return null; });
      })
      .then(function (cart) { return self.announceCart(cart, item, addResp); })
      .then(function () { self.flashAdded(); })
      .catch(function (err) {
        self.setStatus((err && err.message) || 'We couldn’t add that to your cart. Please try again.', 'error');
      })
      .then(function () {
        self.busy = false;
        r.cta.classList.remove('is-busy');
        var spin = r.cta.querySelector('.fab-cta__spin');
        if (spin) spin.remove();
        if (!r.cta.classList.contains('is-added')) self.update();
      });
  };

  P.announceCart = function (cart, item, addResp) {
    var detailData = {
      source: 'product-form-component',
      itemCount: 1,
      productId: String(this.cfg.productId || ''),
      sections: addResp && addResp.sections
    };
    var root = this.root;
    var fire = function (Ev) {
      var ev = Ev ? new Ev(cart || {}, String(item.id), detailData)
        : new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart || {}, sourceId: String(item.id), data: detailData } });
      root.dispatchEvent(ev);
    };
    var openDrawer = function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        try { drawer.open(); return; } catch (e) { /* fall through */ }
      }
      if (!document.querySelector('cart-items-component')) window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    };
    var Ev = window.FineArtBuilderEvents && window.FineArtBuilderEvents.CartAddEvent;
    try { fire(Ev || null); } catch (e) { fire(null); }
    openDrawer();
    return Promise.resolve();
  };

  P.flashAdded = function () {
    var r = this.refs, self = this;
    r.cta.classList.add('is-added');
    r.ctaLabel.textContent = 'Added to your cart';
    this.setStatus('Added. Your print will be made to order in our studio.', 'ok');
    clearTimeout(this.addedTimer);
    this.addedTimer = setTimeout(function () { r.cta.classList.remove('is-added'); self.update(); }, 2600);
  };

  /* ------------------------------------------------------------------ *
   * Public API
   * ------------------------------------------------------------------ */

  window.FineArtBuilder = {
    version: '2.0.0',
    mount: function (root, cfg) { return new Builder(root, cfg); },
    wrapText: wrapText,
    formatMoney: formatMoney,
    parseDims: parseDims
  };

  function autoMount() {
    document.querySelectorAll('[data-fine-art-builder]:not([data-fab-mounted])').forEach(function (root) {
      var dataEl = root.querySelector('script[type="application/json"][data-fab-config]');
      if (!dataEl) return;
      try {
        var cfg = JSON.parse(dataEl.textContent);
        cfg.mode = cfg.mode || 'live';
        root.setAttribute('data-fab-mounted', '');
        new Builder(root, cfg);
      } catch (e) {
        if (window.console) console.error('[FineArtBuilder] Could not start', e);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoMount);
  else autoMount();
  document.addEventListener('shopify:section:load', autoMount);
})();
